module.exports = __webpack_public_path__ + "assets/media/1.a0c97196.wav";